// extracted by mini-css-extract-plugin
export default {"form":"CampaignGalleryModal_form__HVLrP","submitButton":"CampaignGalleryModal_submitButton__x4zh2","youtubeVideoHrefInput":"CampaignGalleryModal_youtubeVideoHrefInput__Nlfll"};